<template>
  <div>
    <b-card>
      <b-form>
        <b-row>
          <b-col>
            <b-form-group
              class="mr-3 ml-3"
              label="دپارتمان"
              label-class="mr-3"
              label-align="left"
              label-for="input_department_name"
            >
              <b-form-input
                id="input_department_name"
                v-model="currentDepartment.name"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group id="des-gr" label="وضعیت:" label-for="des">
              <MDDropdown
                v-bind:group="113"
                v-model="currentDepartment.mdid113_department_status"
              ></MDDropdown>
            </b-form-group>
          </b-col>
          <b-col></b-col>
          <b-col></b-col>
        </b-row>
        <b-button variant="success" @click="editDepartment">ذخیره</b-button>
      </b-form>
    </b-card>
  </div>
</template>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import httpHelper from "../../helpers/httpHelper";
import MDDropdown from "../../components/MDDropdown";

export default {
  name: "EditDepartment",
  components: {
    MDDropdown,
  },
  data: function () {
    return {
      currentDepartment: {
        name: null,
        id: null,
        mdid113_department_status: null,
      },
    };
  },
  methods: {
    getDepartmentById: function (id) {
      httpHelper
        .getData(`departments?id=${id}`)
        .then((response) => {
          this.currentDepartment = response.result[0];
        })
        .catch((error) => {});
    },
    editDepartment: function () {
      httpHelper
        .postData("departments", this.currentDepartment)
        .then((response) => {
          if (response.success) {
            //this.List.splice(this.List.indexOf(this.selected_item), 1);
            this.$makeToast('success','ویرایش دپارتمان',"دپارتمان جدید با موفقیت ویرایش شد",5000)
            this.$router.push("/rp/3");
          }
        })
        .catch((error) => {})
        .finally(() => {});
    },
  },
  mounted() {
    this.getDepartmentById(this.$route.params.id);
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: "دپارتمان های تیکت",
        route: "/rp/3",
      },
      {
        title: "ویرایش دپارتمان",
      },
    ]);
  },
};
</script>